import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  authType: 'email' | 'google' | null;
  googleUser: any | null;
}

const initialState: AuthState = {
  isLoggedIn: false,
  token: null,
  authType: null,
  googleUser: null,
};

const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.isLoggedIn = true;
      state.token = action.payload;
      state.authType = 'email';
    },
    googleLogin: (state, action: PayloadAction<{ user: any; idToken: string }>) => {
      state.isLoggedIn = true;
      state.token = action.payload.idToken;
      state.authType = 'google';
      state.googleUser = action.payload.user;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.authType = null;
      state.googleUser = null;
    },
  },
});

export const { login, googleLogin, logout } = AuthSlice.actions;
export default AuthSlice.reducer;
